import { render, staticRenderFns } from "./3-SubProducts.vue?vue&type=template&id=7ecb0550&scoped=true"
import script from "./3-SubProducts.vue?vue&type=script&lang=js"
export * from "./3-SubProducts.vue?vue&type=script&lang=js"
import style0 from "./3-SubProducts.vue?vue&type=style&index=0&id=7ecb0550&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecb0550",
  null
  
)

export default component.exports